import { CommonModule } from "@angular/common";
import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ApiService } from "src/app/services/api.service";
import { AppSettings } from "src/app/services/AppSettings";
import { CommonValues } from "src/app/services/commonValues";
import { JobService } from "src/app/services/job.service";
import { UtilService } from "src/app/services/util.service";
import { User } from "src/app/types/User";
import { UserCardConfig } from "src/app/types/UserCardConfig";
import Swal from "sweetalert2";
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

declare var $: any;

@Component({
  selector: "app-user-card",
  standalone: true,
  imports: [BsDropdownModule, CommonModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: "./user-card.component.html",
  styleUrls: ["./user-card.component.scss"],
})

export class UserCardComponent implements OnInit {
  private _adminFlag: boolean = false;
  user: User;
  userId: String;
  ready: boolean = false;
  hide: boolean = false;
  selfUser: boolean = false;
  @Output() updateNetworkList = new EventEmitter();
  lblName
  ownerNameMember
  ownerName
  primaryButton: UserCardConfig;
  dropdownList: UserCardConfig[] = [];
  dropdownListTemp: UserCardConfig[] = [];
  bntStyle
  @Input()
  userIdInput: String;

  businessId: any;

  @Input() hideButton: boolean = true;

  @Input()
  userDataInput: User;

  @Input()
  config: UserCardConfig[];

  @Input()
  refresh: boolean = false;

  @Input()
  showFooter: boolean = true;

  /** Wireframe variant only: the "connections · jobs · candidates" line.
   *  The business pages turn it off (not in their wireframe). */
  @Input()
  showStats: boolean = true;

  @Input()
  button: string = "PRIMARY";
  @Input()
  labelName: String;
  // 'wireframe' = the business Employees card (gigsumo-inapp-company-page-Opti.html
  // .member-card). Only business-employee passes it; every other page keeps 'default'.
  @Input() variant: 'default' | 'wireframe' = 'default';
  // Standardised default card (photo + button + ⋮ fit on narrow cards).
  // Turned on page by page; becomes the default once every page is checked.
  @Input() standard: boolean = false;
  @Output() handleEvent = new EventEmitter();
  communityValues: any;
  colors: Array<any> = ["hgreen", "hred", "horange", "hyellow"];
  selColor: string;
  loaded: boolean = false;
  constructor(
    private API: ApiService,
    private router: Router,
    private util: UtilService,
    private _eref: ElementRef,
    private commonvalues: CommonValues,
    private route: Router,
    private _activated_route: ActivatedRoute,
    private JobServicecolor: JobService,
  ) // private connectionData: ConnectionComponent
  {
    this.randomColor();

    this.commonvalues.getcommunitydata().subscribe((res) => {
      this.communityValues = res;
    });

  }

  @Input()
  set adminFlag(adminFlag: boolean) {
    this._adminFlag = adminFlag;
    if (this.ready) {
      if (this.button === "PRIMARY") {
        this.initCard();
      } else {
        this.initSecondaryButton();
      }
    }
  }

  randomColor(): void {
    this.selColor = this.colors[Math.floor(Math.random() * this.colors.length)];
  }


  businessData: any;
  ngOnInit() {
    this._activated_route.queryParams.subscribe(res => {
      this.businessData = res
    })
    // // this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.showName();
    let loggedInUser = localStorage.getItem("userId");
    if (this.userDataInput == null || this.userDataInput == undefined) {

      if (loggedInUser == this.userIdInput) {
        this.selfUser = true;
        this.lblName = this.labelDisplay(this.labelName);
      }
      this.initUserData(this.userIdInput);
    } else {

      this.user = this.userDataInput;

      this.userId = this.user.userId;
      if (loggedInUser == this.userId) {
        this.selfUser = true;
        this.lblName = this.labelDisplay(this.labelName);
      }

      if (this.userDataInput && this.userDataInput.photo) {
        const baseUrl = AppSettings.photoUrl;
        const photo = this.userDataInput.photo;

        // Check if the photo URL already contains the base URL
        if (!photo.startsWith(baseUrl)) {
          this.user.photo = baseUrl + photo;
        } else {
          this.user.photo = photo;
        }
      } 

      this.initBtnCard()
    }

    if (loggedInUser == this.userId) {
      this.selfUser = true;
      this.lblName = this.labelDisplay(this.labelName);
    }

  }

  labelDisplay(labelName) {

    if (labelName == "NETWORK" || labelName == "TEAM") {
      if (this.userDataInput.label_Id == localStorage.getItem("userId")) {
        return "Owner";
      } else if (this.userDataInput.userId == localStorage.getItem("userId")) {
        return "You";
      }
    } else if (labelName == "BUSINESS" || labelName == "COMMUNITY" || labelName == undefined) {
      return "You";
    }
  }

  showName() {

    if (this.labelName == "NETWORK" || this.labelName == "TEAM") {
      if (this.userDataInput.label_Id != localStorage.getItem("userId") &&
        this.userDataInput.userId == this.userDataInput.label_Id) {
        this.ownerNameMember = "( Owner )"
        this.ownerName = "Owner"

      }

    }
  }

  initBtnCard() {
    if (this.button === "PRIMARY") {
      this.initCard();
    } else {
      this.initSecondaryButton();
    }
  }
  // Readable labels for each userType. Used as the card's title fallback:
  // when a user has no `title`/`requestSentTitle`, we show their userType
  // (e.g. "Bench Recruiter") instead of leaving the title line blank.
  private readonly userTypeLabelMap: { [key: string]: string } = {
    MANAGEMENT_TALENT_ACQUISITION: 'Management Talent Acquisition',
    FREELANCE_RECRUITER: 'Freelance Recruiter',
    BENCH_RECRUITER: 'Bench Recruiter',
    RECRUITER: 'Recruiter',
    JOB_SEEKER: 'Job Seeker',
  };

  // Returns a human-readable userType label; falls back to the raw value with
  // underscores replaced so an unmapped type still renders something sensible.
  getUserTypeLabel(userType: any): string {
    if (!userType) {
      return '';
    }
    const key = String(userType).trim();
    return this.userTypeLabelMap[key] || key.replace(/_/g, ' ');
  }

  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }

  initUserData(userId: String) {
    this.userId = userId;
    this.util.startLoader();
    this.API.query("user/" + userId).subscribe((res) => {
      this.util.stopLoader();
      let tempUser: User = new User();
      tempUser.userId = userId;
      tempUser.username = res.username;
      tempUser.firstName = res.firstName;
      tempUser.lastName = res.lastName;
      tempUser.photo = res.photo ? AppSettings.photoUrl + res.photo : null;
      tempUser.organisation = res.organisation;
      tempUser.title = res.title;
      tempUser.connected = res.connected;
      tempUser.connectionStatus = res.connectionStatus;
      tempUser.connectionCnt = res.connectionCnt;
      tempUser.postCnt = res.postCnt;
      this.user = tempUser;

      this.initBtnCard();
    }, err => {
      this.util.stopLoader();
    });
  }

  initAdminButton(): void {

    this.dropdownList = [];
    let buttonConfig: UserCardConfig[] = [];
    if (this.config != undefined) {
      this.config.forEach((element) => {
        let add = element.canShow.apply(element.source, [
          this.user,
          element.source,
        ]);
        if ((this._adminFlag || add == true || add == "true") && this.businessData.viewingAsMember != 'true') {
          buttonConfig.push(element);
        }
      });
    }
    this.dropdownList = buttonConfig;
    this.dropdownListTemp = buttonConfig;
    this.ready = true;
  }

  initSecondaryButton(): void {

    if (this.button === "ADMIN") {
      this.initAdminButton();
    } else {
      this.dropdownList = [];
      let buttonConfig: UserCardConfig[] = this.commonCardButton();
      if (this.config != undefined) {
        this.config.forEach((element) => {
          let add = element.canShow.apply(element.source, [
            this.user,
            element.source,
          ]);
          if ((this._adminFlag || add == true || add == "true") && this.businessData.viewingAsMember != 'true') {
            buttonConfig.push(element);
          }
        });
      }
      this.dropdownList = buttonConfig;
      this.dropdownListTemp = buttonConfig;

      this.ready = true;
    }
  }

  private commonCardButton(): any {
    let buttonConfig: UserCardConfig[] = [];
    const currentUserId = localStorage.getItem("userId");
    
    // Don't show any buttons for own card
    if (this.user.userId === currentUserId) {
      return buttonConfig;
    }
    
    // For employee request pages, don't show connection buttons - they use their own config buttons
    if (this.user.page === "employeerequest") {
      return buttonConfig;
    }
    
    if (this.user.connectionStatus == "NOT_CONNECTED" || !this.user.connectionStatus) {
      // Show Connect button for users who haven't sent/received requests
      let connect: UserCardConfig = new UserCardConfig(
        "Connect",
        this.connect,
        null,
        true
      );
      connect.source = this;
      buttonConfig.push(connect);
    } else if (this.user.connectionStatus == "REQUEST_SENT" || this.user.connectionStatus == "REQUEST_RECEIVED") {
      // REQUEST_SENT: current user sent a request to someone else
      // REQUEST_RECEIVED: current user received a request from someone else
      
      if (this.user.connectionStatus == "REQUEST_SENT") {
        // Handle REQUEST_SENT based on context
        if (this.user.page == "connectionList") {
          // Connection page: user viewing their own sent requests - show Cancel Request button
          let cancelRequest: UserCardConfig = new UserCardConfig(
            "Cancel Request",
            this.cancelConnectionRequest,
            null,
            true
          );
          cancelRequest.source = this;
          buttonConfig.push(cancelRequest);
        }
        // For business-employee context: no primary button (prevents green horizontal line)
      } else if (this.user.connectionStatus == "REQUEST_RECEIVED" || 
          (this.user.requestedBy && this.user.requestedBy !== currentUserId)) {
        // Current user received the request - show Accept Request button
        let acceptRequest: UserCardConfig = new UserCardConfig(
          "Accept Request",
          this.acceptRequest,
          null,
          true
        );
        acceptRequest.source = this;
        buttonConfig.push(acceptRequest);
        
        let rejectRequest: UserCardConfig = new UserCardConfig(
          "Reject Request",
          this.rejectRequest,
          null,
          true
        );
        rejectRequest.source = this;
        if(this.user.page!='employeerequest'){
          buttonConfig.push(rejectRequest);
        }
      }
    } else if (this.user.connectionStatus == "REQUEST_PENDING") {
      // REQUEST_PENDING status - handle different contexts properly
      if (this.user.page == "connectionList") {
        // Connection page context: REQUEST_PENDING means received requests (from connection.component.ts mapping)
        let acceptRequest: UserCardConfig = new UserCardConfig(
          "Accept Request",
          this.acceptRequest,
          null,
          true
        );
        acceptRequest.source = this;
        buttonConfig.push(acceptRequest);
        
        let rejectRequest: UserCardConfig = new UserCardConfig(
          "Reject Request",
          this.rejectRequest,
          null,
          true
        );
        rejectRequest.source = this;
        buttonConfig.push(rejectRequest);
      } else {
        // Business-employee context: check who sent the request
        if (this.user.requestedBy && this.user.requestedBy !== currentUserId) {
          // Current user received the request - show Accept Request (business-employee fix preserved)
          let acceptRequest: UserCardConfig = new UserCardConfig(
            "Accept Request",
            this.acceptRequest,
            null,
            true
          );
          acceptRequest.source = this;
          buttonConfig.push(acceptRequest);
          
          let rejectRequest: UserCardConfig = new UserCardConfig(
            "Reject Request",
            this.rejectRequest,
            null,
            true
          );
          rejectRequest.source = this;
          if(this.user.page!='employeerequest'){
            buttonConfig.push(rejectRequest);
          }
        }
        // If current user sent request in business-employee context: no primary button (prevents green line)
      }
    } else if (
      (this.user.connectionStatus == "CONNECTED" ||
        this.user.connected)
    ) {
      // Both sides should see Send Message button as PRIMARY after connection
      let sendMessage: UserCardConfig = new UserCardConfig(
        "Send Message",
        this.sendMessage,
        null,
        true
      );
      sendMessage.source = this;
      buttonConfig.push(sendMessage);
    }
    return buttonConfig;
  }


  revokeMemberCommunity(data) {
    data.userId;
    data.communityId;

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure you want to remove?",
        text: "This member will be removed from this community page",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          let datas: any = {};
          datas.communityId = data.communityId;
          datas.userId = data.userId;
          this.util.startLoader();
          this.API
            .create("community/remove/members", datas)
            .subscribe((res) => {
              this.util.stopLoader();
              if (res.code == "00000") {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Community member",
                  text: "Member has been removed",
                  showConfirmButton: false,
                  timer: 2000,
                }).then(() => {
                  var obj: any = {}
                  obj.boolean = true
                  this.commonvalues.setCommunityEventEmitter(obj)
                })
              }
            }, err => {
              this.util.stopLoader();

            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      });
  }
  ulbutton: boolean = false;

  /** True when this card's user is the business Owner / Super Admin — the same
   *  condition that renders the crown (user-card.component.html:15). A Super
   *  Admin is a default follower and must not be revocable by an Admin, so the
   *  Revoke action is withheld for them (see initCard). */
  get isUserOwner(): boolean {
    return this.user?.type === 'SUPERADMIN'
      || this.user?.businessUserType === 'SUPERADMIN'
      || this.user?.isAdmin === true;
  }

  initCard(): void {

    // Get connection-related buttons (Connect, Accept Request, Send Message)
    let buttonConfig: UserCardConfig[] = this.commonCardButton();
    let dropdownButtons: UserCardConfig[] = [];

    if (!this.selfUser) {
      if ((this.user.connectionStatus == "CONNECTED" || this.user.connected) && this.user.page == 'connectionList') {
        let removeConnection: UserCardConfig = new UserCardConfig(
          "Remove Connection",
          this.removeConnection,
          null,
          true
        );
        removeConnection.source = this;
        buttonConfig.push(removeConnection);
      }
    }

    // Handle config buttons (like Revoke) - separate primary vs dropdown
    if (this.config != undefined) {
      this.config.forEach((element) => {
        // Never offer Revoke on the Owner / Super Admin: they are a default
        // follower of the page and an Admin must not be able to revoke them.
        // Guard here (before the _adminFlag branch below, which otherwise
        // force-adds config buttons and bypasses canShow).
        if (element.buttonName === 'Revoke' && this.isUserOwner) {
          return;
        }
        let add = element.canShow.apply(element.source, [
          this.user,
          element.source,
        ]);

        if ((this._adminFlag || add == true || add == "true") && this.businessData.viewingAsMember != 'true') {
          // Check if this is a primary button or dropdown button based on 'show' property
          if (element.show === true) {
            // This is a primary button
            buttonConfig.push(element);
          } else {
            // This goes in dropdown (three-dot menu)
            dropdownButtons.push(element);
          }
        } else if (this.user.page === "employeerequest" && (add == true || add == "true")) {
          // Special handling for employee request pages - always show configured buttons
          // regardless of adminFlag or viewingAsMember status
          if (element.show === true) {
            buttonConfig.push(element);
          } else {
            dropdownButtons.push(element);
          }
        }
      });
    }

    // Set primary button (first connection-related button)
    this.primaryButton = buttonConfig[0];

    // Set dropdown list: remaining connection buttons + administrative buttons
    let remainingConnectionButtons = buttonConfig.slice(1);
    this.dropdownList = [...remainingConnectionButtons, ...dropdownButtons];

    // Handle special cases
    if (this.userDataInput.showAccept) {
      this.config.forEach((ele: UserCardConfig, i: number) => {
        if (ele.buttonName === "Accept") {
          this.primaryButton = ele;
          this.hideButton = true;
        }
      });

      if (this.userDataInput.ignoredUser || this.userDataInput.deniedUser) {
        // Ignored / Denied employees: keep the three-dot menu visible.
        // Previously this set ulbutton=true and replaced dropdownList with a
        // placeholder ([{ show: true }]), which hid the toggle entirely
        // (template gates it on `dropdownList?.length > 0 && !ulbutton`) — that
        // is why the 3-dot went missing on the Ignored/Denied filters.
        //
        // Accept stays the primary action (restores the employee). The menu
        // keeps the remaining moderation action but drops the redundant one:
        // no "Ignore" on an already-ignored user, no "Deny" on a denied one.
        this.ulbutton = false;
        const redundantAction = this.userDataInput.ignoredUser ? "Ignore" : "Deny";
        this.dropdownList = this.dropdownList.filter(
          (btn: any) => btn && btn.buttonName !== "Accept" && btn.buttonName !== redundantAction
        );
        this.ready = true;
        return;
      }
    }

    this.ready = true;
  }

  onclick(buttonConfig: UserCardConfig) {
    if (buttonConfig.buttonName == "Remove Connection" || buttonConfig.buttonName == "Reject Request" || buttonConfig.buttonName == "Cancel Request") {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      var text = buttonConfig.buttonName.toLowerCase()
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "Do you want to " + text + " for this user?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes ",
          cancelButtonText: "No",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            buttonConfig.clickHandler.apply(buttonConfig.source, [
              this.user,
              buttonConfig.source,
            ]);
          } else if (result.dismiss === Swal.DismissReason.cancel) { }
        });


    } else {
      buttonConfig.clickHandler.apply(buttonConfig.source, [
        this.user,
        buttonConfig.source,
      ]);
    }
  }



  connect(user: User) {
    let datas: any = {};
    datas.userId = user.userId;
    datas.requestedBy = localStorage.getItem('userId');
    this.util.startLoader();
    this.API.create("user/connect", datas).subscribe((conData) => {
      this.util.stopLoader();
      console.warn("Connection Response data: ", conData);
      if (conData.code === "00000") {
        Swal.fire({
          icon: "success",
          title: "Connection request sent successfully",
          showConfirmButton: false,
          timer: 2000,
        }).then((result) => {
          this.emitEvent("Connection request sent successfully", user);
        });
        this.user.connected = false;
        this.user.connectionStatus = "REQUEST_SENT";
        this.user.requestedBy = localStorage.getItem('userId'); // Set who sent the request
        this.initBtnCard();
      } else if (conData.code === "88888") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops..",
          text: "Sorry, connection request failed. Please try after some time",
          showConfirmButton: false,
          timer: 3000,
        });

      }
    }, err => {
      this.util.stopLoader();
    });
  }

  acceptRequest(user: User) {

    let data: any = {};
    data.connectedUser = this.userId;
    data.status = "CONNECTED";

    this.util.startLoader();
    this.API.create("user/connect/accept", data).subscribe((conData) => {
      this.util.stopLoader();
      console.warn("Connection Response data: ", conData);
      if (conData.code === "00000") {
        this.user.connected = true;
        this.user.connectionStatus = "CONNECTED";
        this.dropdownList = this.dropdownListTemp;
        this.emitEvent("ACCEPTCONNECT", user);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Connection Accepted successfully",
          showConfirmButton: false,
          timer: 3000,
        });

        // TODO: Emit event for profile status refresh instead of direct component call
        // this.userbadges.profileStatus();
        this.initBtnCard();





      } else if (conData.code === "88889") {

        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops..",
          text: "Sorry, accept request failed. Please try after some time",
          showConfirmButton: false,
          timer: 3000,
        });

      }
    }, err => {
      this.util.stopLoader();

    });
  }

  rejectRequest(user: User) {
    let data: any = {};
    data.connectedUser = this.userId;
    data.status = "REJECTED";
    this.util.startLoader();

    this.API.create("user/connect/accept", data).subscribe((conData) => {
      this.util.stopLoader();
      console.warn("Connection Response data: ", conData);
      if (conData.code === "00000") {
        // TODO: Emit event for profile status refresh instead of direct component call
        // this.userbadges.profileStatus();
        Swal.fire({
          icon: "success",
          title: "Connection has been rejected",
          showConfirmButton: false,
          timer: 2000,
        }).then((result) => {
          this.emitEvent("REJECTEDCONNECT", user);
        });

        this.user.connected = false;
        this.user.connectionStatus = "NOT_CONNECTED";
        this.initBtnCard();
      } else if (conData.code === "88889") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops..",
          text: "Sorry, reject request failed. Please try after some time",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }, err => {
      this.util.stopLoader();

    });
  }

  cancelConnectionRequest(user: User) {

    let cancelData: any = {};
    cancelData.userId = user.userId;

    this.util.startLoader();
    this.API.create("user/connect/cancel", cancelData).subscribe((res) => {
      this.util.stopLoader();

      if (res.code === "00000") {

        Swal.fire({
          icon: "success",
          title: "Connection request cancelled",
          showConfirmButton: false,
          timer: 2000,
        }).then((result) => {
          this.emitEvent("CANCEL_CONNECT_REQUEST", user);
        });

        this.user.connectionStatus = "NOT_CONNECTED";
        this.initBtnCard();
      } else if (res.code === "88888") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops..",
          text: "Sorry, unable to cancel connection",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    }, err => {
      this.util.stopLoader();

    });
  }


  removeConnection(user: User) {
    let connData: any = {};
    connData.userId = user.userId;
    this.util.startLoader();
    this.API.create("user/connect/remove", connData).subscribe((res) => {
      this.util.stopLoader();

      // TODO: Emit event for profile status refresh instead of direct component call
      // this.userbadges.profileStatus();
      if (res.code === "00000") {

        Swal.fire({
          icon: "success",
          title: "Connection removed",
          showConfirmButton: false,
          timer: 2000,
        }).then((result) => {

        });

        this.user.connectionStatus = "NOT_CONNECTED";
        this.user.connected = false;
        this.initBtnCard();
        this.emitEvent("REMOVE_CONNECTION", user);
        if (this.user.page == 'COMMUNITY' && this.user.type == 'SUPERADMIN') {
          const queryParams: Params = { menu: user.menu };
          this.route.navigate([], {
            relativeTo: this._activated_route,
            queryParams: queryParams,
            queryParamsHandling: 'merge',
          });
          window.scrollTo(0, 0);

        }

      } else if (res.code === "88888") {
        this.emitEvent("NOT_CONNECTED", user);
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops..",
          text: "Connection request failed. Please try after some time",
          showConfirmButton: false,
          timer: 1500,
        });

      }
    }, err => {
      this.util.stopLoader();

    });
  }

  emitEvent(event: String, data: User) {
    var cardEvent = {
      event: event,
      data: data,
    };
    this.handleEvent.emit(cardEvent);
  }

  sendMessage(user: User) {
    var userData: any = {};
    userData.groupId = user.userId;
    userData.type = "USER";
    this.router.navigate(["message"], { queryParams: userData });
  }

  navigateUserProfile(user: User) {
    var userData: any = {};
    userData.userId = user.userId;

    this.router.navigate(["personalProfile"], { queryParams: userData });

  }

  // ── variant 'wireframe' helpers. Same rules as the default template's primary button and
  // ⋮ toggle, gathered here so the wireframe branch can't drift from them.
  get wfShowPrimary(): boolean {
    const u: any = this.user;
    if (!u || this.selfUser || !this.primaryButton?.buttonName) { return false; }
    const shown = this.hideButton && (
      u.page == 'connectionList' ||
      u.connectionStatus == 'NOT_CONNECTED' || u.connectionStatus == 'CONNECTED' ||
      u.connectionStatus == 'REQUEST_RECEIVED' ||
      (u.connectionStatus == 'REQUEST_PENDING' && u.requestedBy && u.requestedBy !== this.businessData?.userId) ||
      u.page == 'employeerequest');
    const pendingAlt = this.ulbutton && u.connectionStatus == 'REQUEST_PENDING'
      && u.page != 'connectionList' && u.page != 'employeerequest';
    return !!(shown || pendingAlt);
  }

  get wfShowMenu(): boolean {
    const u: any = this.user;
    if (this.selfUser || !(this.dropdownList?.length > 0)) { return false; }
    return !this.ulbutton || (u?.page == 'COMMUNITY' && u?.menu == 'memberspage');
  }

  get wfLocation(): string {
    const u: any = this.user;
    return [u?.city, u?.state, u?.country].filter(p => p && String(p).trim()).join(', ');
  }

  // Compact stats line; same counts per user type as the default card's footer.
  get wfStats(): string {
    const u: any = this.user;
    if (!u) { return ''; }
    const n = (v: any) => (v != null ? v : 0);
    const parts: string[] = [];
    const t = u.userType;
    if (['RECRUITER', 'BENCH_RECRUITER', 'JOB_SEEKER', 'MANAGEMENT_TALENT_ACQUISITION', 'FREELANCE_RECRUITER'].includes(t)) {
      parts.push(`${n(u.connectionCnt)} connections`);
    }
    if (['RECRUITER', 'MANAGEMENT_TALENT_ACQUISITION', 'FREELANCE_RECRUITER'].includes(t)) {
      parts.push(`${n(u.jobsCount)} jobs`);
    }
    if (['BENCH_RECRUITER', 'JOB_SEEKER', 'MANAGEMENT_TALENT_ACQUISITION', 'FREELANCE_RECRUITER'].includes(t)) {
      parts.push(`${n(u.candidatesCount)} candidates`);
    }
    return parts.join(' · ');
  }
  //member network
  connectionrequest(value, action: 'ACCEPT' | 'REJECT') {
    const data = {
      userId: localStorage.getItem("userId"),
      //businessNetworkId: value,
      status: action === 'ACCEPT' ? "CONNECTED" : "REJECTED",
    };

    const successMessage = action === 'ACCEPT'
      ? "Request accepted successfully"
      : "Connection request rejected";

    this.util.startLoader();
    this.API.updatePut("business/updateBusinessUsersContact", data).subscribe(
      (res) => {
        this.util.stopLoader();
        if (res.code == "00000") {
          Swal.fire({
            icon: "success",
            title: successMessage,
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.updateNetworkList.emit(null);
          });
        } else {
          Swal.fire({
            icon: "info",
            title: "Oops...",
            text: action === 'ACCEPT'
              ? "Connection accept request failed. Please try after a while."
              : "Something went wrong. Please try after some time",
            showConfirmButton: false,
            timer: 4000,
          });
        }
      },
      (error) => {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong. Please try again later.",
          showConfirmButton: false,
          timer: 4000,
        });
      }
    );
  }
  removeUserContact(businessId) {
    this.util.startLoader();
    this.API.delete(`business/removeBusinessUsersContact/${businessId}/${this.userId}`).subscribe(
      (res) => {
        this.util.stopLoader();
        if (res.code === '00000') {
          Swal.fire({
            icon: 'success',
            title: 'Contact removed successfully',
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.updateNetworkList.emit(null);
          });
        }
      },
      (error) => {
        this.util.stopLoader();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong. Please try again later.',
          showConfirmButton: false,
          timer: 4000,
        });
      }
    );
  }
}

